import { isUserRoleAssignmentResponse, } from '@urbanik/api-contracts';
import { AdminUsersApiError } from './admin-users.js';
async function parse(response) {
    if (!response.ok) {
        const payload = (await response.json().catch(() => null));
        const message = payload?.message ?? 'No pudimos completar la operación.';
        if (response.status === 401)
            throw new AdminUsersApiError('unauthorized', message);
        if (response.status === 403)
            throw new AdminUsersApiError('forbidden', message);
        if (response.status === 400)
            throw new AdminUsersApiError('validation', message);
        if (response.status === 409)
            throw new AdminUsersApiError('conflict', message);
        throw new AdminUsersApiError('unavailable', message);
    }
    const payload = await response.json();
    if (!isUserRoleAssignmentResponse(payload))
        throw new AdminUsersApiError('unavailable', 'La respuesta de roles del usuario no es válida.');
    return payload;
}
export async function getUserRoleAssignment(baseUrl, userId) {
    try {
        return await parse(await fetch(`${baseUrl.replace(/\/$/, '')}/identity/users/${encodeURIComponent(userId)}/roles`, {
            credentials: 'include',
            headers: { Accept: 'application/json' },
        }));
    }
    catch (error) {
        if (error instanceof AdminUsersApiError)
            throw error;
        throw new AdminUsersApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
}
export async function replaceUserRoles(baseUrl, userId, input) {
    try {
        return await parse(await fetch(`${baseUrl.replace(/\/$/, '')}/identity/users/${encodeURIComponent(userId)}/roles`, {
            method: 'PUT',
            credentials: 'include',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(input),
        }));
    }
    catch (error) {
        if (error instanceof AdminUsersApiError)
            throw error;
        throw new AdminUsersApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
}
